import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useMemo, useRef } from 'react';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import Lottie from 'lottie-react';
import { css, useTheme, jsx } from '@emotion/react';
import { devWarning, utilStyles, KeyboardCode } from '@paypalcorp/pp-react-utils';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';

var _templateObject;
function styles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    devWarning('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var _utilStyles = utilStyles(tokens),
      focusStyles = _utilStyles.focusStyles;

  var sysSizePictogramLg = tokens.sysSizePictogramLg;
  var animatedPictogram = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    label: animated_pictogram;\n    height: ", ";\n    width: ", ";\n    position: relative;\n\n    &:focus {\n      ", "\n    }\n  "])), sysSizePictogramLg, sysSizePictogramLg, focusStyles.focusOffsetElement);
  return {
    animatedPictogram: animatedPictogram
  };
}

var _excluded = ["animationData", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var LottieContainer = function (_ref) {
  var animationData = _ref.animationData,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var tokens = useTheme();

  var _styles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);

  var isPaused = useRef(false);
  var lottieRef = useRef();

  var handleAnimation = function () {
    if (isPaused.current) {
      var _lottieRef$current;

      // @ts-ignore
      // eslint-disable-next-line no-unused-expressions
      (_lottieRef$current = lottieRef.current) === null || _lottieRef$current === void 0 ? void 0 : _lottieRef$current.play();
    } else {
      var _lottieRef$current2;

      // @ts-ignore
      // eslint-disable-next-line no-unused-expressions
      (_lottieRef$current2 = lottieRef.current) === null || _lottieRef$current2 === void 0 ? void 0 : _lottieRef$current2.pause();
    }

    isPaused.current = !isPaused.current;
  };

  var componentProps = _objectSpread({
    className: className,
    animationData: animationData,
    lottieRef: lottieRef,
    onKeyDown: function keyHandler(event) {
      /* istanbul ignore next */
      var KeyCode = new KeyboardCode(event.key || event.keyCode);

      if (KeyCode.IS_ENTER || KeyCode.IS_SPACEBAR) {
        event.preventDefault();
        handleAnimation();
      }
    },
    onClick: handleAnimation,
    css: _styles.animatedPictogram,
    loop: true,
    'data-ppui-info': ''
  }, rest);

  return jsx(Lottie, _extends({}, componentProps, {
    "data-ppui": "true"
  }));
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var AwardAchievedPictogram = function (props) {
  var componentProps = _objectSpread$1({
    'aria-label': 'award-achieved'
  }, props);

  return /*#__PURE__*/React.createElement(LottieContainer, _extends({}, componentProps, {
    animationData: {
      v: '4.8.0',
      meta: {
        g: 'LottieFiles AE 3.1.1',
        a: '',
        k: '',
        d: '',
        tc: ''
      },
      fr: 25,
      ip: 0,
      op: 251,
      w: 200,
      h: 200,
      nm: '002 Award Achieved - Revolve',
      ddd: 0,
      assets: [],
      layers: [{
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: 'Mask 2',
        td: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [100.635, 82.728, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [40.64, 40.64, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[0, 0], [0, 0]],
                o: [[0, 0], [0, 0]],
                v: [[27.75, -4], [-13.5, 47]],
                c: false
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'st',
            c: {
              a: 0,
              k: [1, 0, 0, 1],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 16,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: 'Stroke 1',
            mn: 'ADBE Vector Graphic - Stroke',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Shape 2',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }, {
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[0, 0], [0, 0]],
                o: [[0, 0], [0, 0]],
                v: [[-3.75, 47.5], [-33, 21.25]],
                c: false
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'st',
            c: {
              a: 0,
              k: [1, 0, 0, 1],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 16,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: 'Stroke 1',
            mn: 'ADBE Vector Graphic - Stroke',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false
        }, {
          ty: 'tm',
          s: {
            a: 0,
            k: 100,
            ix: 1
          },
          e: {
            a: 1,
            k: [{
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.75],
                y: [0]
              },
              t: 75,
              s: [100]
            }, {
              t: 85,
              s: [0]
            }],
            ix: 2
          },
          o: {
            a: 0,
            k: 0,
            ix: 3
          },
          m: 2,
          ix: 3,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false
        }],
        ip: 75,
        op: 297,
        st: 37,
        bm: 0
      }, {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: 'Check 2',
        tt: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [99.681, 91.825, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [142.098, 142.098, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[0, 0], [0.347, -0.43], [0, 0], [0.427, 0.38], [0, 0], [-0.367, 0.413], [0, 0], [-0.413, -0.367], [0, 0], [-0.359, 0.444], [0, 0], [-0.43, -0.347]],
                o: [[0.43, 0.347], [0, 0], [-0.359, 0.444], [0, 0], [-0.413, -0.367], [0, 0], [0.367, -0.413], [0, 0], [0.427, 0.38], [0, 0], [0.347, -0.43], [0, 0]],
                v: [[9.268, -6.648], [9.418, -5.241], [-1.137, 7.837], [-2.58, 7.956], [-9.305, 1.974], [-9.388, 0.563], [-7.971, -1.03], [-6.559, -1.113], [-3.073, 1.988], [-1.63, 1.868], [6.203, -7.837], [7.609, -7.987]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.188235309077, 0.529411764706, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 75,
        op: 295,
        st: 82,
        bm: 0
      }, {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: 'Mask 3',
        td: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [100.635, 82.728, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [40.64, 40.64, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[0, 0], [0, 0]],
                o: [[0, 0], [0, 0]],
                v: [[-33, 21.25], [-3.75, 47.5]],
                c: false
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'st',
            c: {
              a: 0,
              k: [1, 0, 0, 1],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 16,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: 'Stroke 1',
            mn: 'ADBE Vector Graphic - Stroke',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }, {
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[0, 0], [0, 0]],
                o: [[0, 0], [0, 0]],
                v: [[-13.5, 47], [27.75, -4]],
                c: false
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'st',
            c: {
              a: 0,
              k: [1, 0, 0, 1],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 16,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: 'Stroke 1',
            mn: 'ADBE Vector Graphic - Stroke',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Shape 2',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false
        }, {
          ty: 'tm',
          s: {
            a: 1,
            k: [{
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.75],
                y: [0]
              },
              t: 55,
              s: [0]
            }, {
              t: 65,
              s: [100]
            }],
            ix: 1
          },
          e: {
            a: 0,
            k: 100,
            ix: 2
          },
          o: {
            a: 0,
            k: 0,
            ix: 3
          },
          m: 2,
          ix: 3,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false
        }],
        ip: -77,
        op: 76,
        st: 26,
        bm: 0
      }, {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: 'Check 3',
        tt: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [99.681, 91.825, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [142.098, 142.098, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[0, 0], [0.347, -0.43], [0, 0], [0.427, 0.38], [0, 0], [-0.367, 0.413], [0, 0], [-0.413, -0.367], [0, 0], [-0.359, 0.444], [0, 0], [-0.43, -0.347]],
                o: [[0.43, 0.347], [0, 0], [-0.359, 0.444], [0, 0], [-0.413, -0.367], [0, 0], [0.367, -0.413], [0, 0], [0.427, 0.38], [0, 0], [0.347, -0.43], [0, 0]],
                v: [[9.268, -6.648], [9.418, -5.241], [-1.137, 7.837], [-2.58, 7.956], [-9.305, 1.974], [-9.388, 0.563], [-7.971, -1.03], [-6.559, -1.113], [-3.073, 1.988], [-1.63, 1.868], [6.203, -7.837], [7.609, -7.987]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.188235309077, 0.529411764706, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: -75,
        op: 78,
        st: -24,
        bm: 0
      }, {
        ddd: 0,
        ind: 8,
        ty: 4,
        nm: 'Shape Layer 3',
        parent: 9,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [-0.948, 2.586, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [-1.375, 3.75, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [68.966, 68.966, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 1,
              k: [{
                i: {
                  x: 0.25,
                  y: 1
                },
                o: {
                  x: 0.75,
                  y: 0
                },
                t: 55,
                s: [{
                  i: [[0, 0], [0, 0], [-26.5, 0], [-28, 0]],
                  o: [[0, 0], [0, 0], [27.75, 0], [28, 0]],
                  v: [[42.75, -11.75], [-45.5, -11.75], [-17.25, 19.25], [15, 19]],
                  c: true
                }]
              }, {
                i: {
                  x: 0.25,
                  y: 1
                },
                o: {
                  x: 0.75,
                  y: 0
                },
                t: 70,
                s: [{
                  i: [[0, 0], [0, 0], [-26.5, 0], [-28, 0]],
                  o: [[0, 0], [0, 0], [27.75, 0], [28, 0]],
                  v: [[25.25, -11.75], [-28.016, -12], [-1.75, 19], [-0.516, 19]],
                  c: true
                }]
              }, {
                t: 85,
                s: [{
                  i: [[0, 0], [0, 0], [-26.5, 0], [-28, 0]],
                  o: [[0, 0], [0, 0], [27.75, 0], [28, 0]],
                  v: [[42.75, -11.75], [-45.5, -11.75], [-17.25, 19.25], [15, 19]],
                  c: true
                }]
              }],
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'st',
            c: {
              a: 0,
              k: [0.980392216701, 0.972549079446, 0.960784373564, 1],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 7,
              ix: 5
            },
            lc: 2,
            lj: 2,
            bm: 0,
            nm: 'Stroke 1',
            mn: 'ADBE Vector Graphic - Stroke',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: -59,
        op: 280,
        st: -59,
        bm: 0
      }, {
        ddd: 0,
        ind: 9,
        ty: 4,
        nm: 'Layer 2',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [98.937, 161.341, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [-0.722, 42.5, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [147.32, 147.32, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 1,
              k: [{
                i: {
                  x: 0,
                  y: 1
                },
                o: {
                  x: 0.75,
                  y: 0
                },
                t: 55,
                s: [{
                  i: [[0, 0], [-1.826, 0], [0, 0], [0, 0], [0, -1.826], [0, 0], [6.466, -9.652], [0.525, -5.58], [-0.042, -0.006], [2.784, 5.531], [0, 0]],
                  o: [[0, -1.826], [0, 0], [0, 0], [1.826, 0], [0, 0], [0, 0], [-2.784, 5.531], [0.107, 0.08], [-0.525, -5.58], [-7.436, -12.755], [0, 0]],
                  v: [[-20.555, -20.306], [-17.25, -23.611], [-0.668, -23.611], [15.806, -23.611], [19.111, -20.306], [19.111, -10.389], [10.258, 16.031], [4.548, 32.937], [-5.992, 32.937], [-11.702, 16.031], [-20.555, -10.389]],
                  c: true
                }]
              }, {
                i: {
                  x: 0.25,
                  y: 1
                },
                o: {
                  x: 0.81,
                  y: 0
                },
                t: 66,
                s: [{
                  i: [[0, 0], [-1.826, 0], [0, 0], [0, 0], [0, -1.826], [0, 0], [6.466, -9.652], [0.525, -5.58], [0, -0.092], [2.784, 5.531], [0, 0]],
                  o: [[0, -1.826], [0, 0], [0, 0], [1.826, 0], [0, 0], [0, 0], [-2.784, 5.531], [0, 0.08], [-0.525, -5.58], [-7.436, -12.755], [0, 0]],
                  v: [[-18.831, -20.306], [-15.525, -23.611], [-0.69, -23.266], [14.082, -23.611], [17.387, -20.306], [17.387, -10.389], [8.534, 16.031], [2.824, 33.017], [-4.268, 32.937], [-9.977, 16.031], [-18.831, -10.389]],
                  c: true
                }]
              }, {
                i: {
                  x: 0,
                  y: 1
                },
                o: {
                  x: 0.75,
                  y: 0
                },
                t: 74,
                s: [{
                  i: [[0, 0], [-1.826, 0], [0, 0], [0, 0], [0, -1.826], [0, 0], [6.466, -9.652], [0.525, -5.58], [0, -0.092], [2.784, 5.531], [0, 0]],
                  o: [[0, -1.826], [0, 0], [0, 0], [1.826, 0], [0, 0], [0, 0], [-2.784, 5.531], [0, 0.08], [-0.525, -5.58], [-7.436, -12.755], [0, 0]],
                  v: [[-18.831, -20.306], [-15.525, -23.611], [-0.69, -23.266], [14.082, -23.611], [17.387, -20.306], [17.387, -10.389], [8.534, 16.031], [2.824, 33.017], [-4.268, 32.937], [-9.977, 16.031], [-18.831, -10.389]],
                  c: true
                }]
              }, {
                t: 85,
                s: [{
                  i: [[0, 0], [-1.826, 0], [0, 0], [0, 0], [0, -1.826], [0, 0], [6.466, -9.652], [0.525, -5.58], [-0.042, -0.006], [2.784, 5.531], [0, 0]],
                  o: [[0, -1.826], [0, 0], [0, 0], [1.826, 0], [0, 0], [0, 0], [-2.784, 5.531], [0.107, 0.08], [-0.525, -5.58], [-7.436, -12.755], [0, 0]],
                  v: [[-20.555, -20.306], [-17.25, -23.611], [-0.668, -23.611], [15.806, -23.611], [19.111, -20.306], [19.111, -10.389], [10.258, 16.031], [4.548, 32.937], [-5.992, 32.937], [-11.702, 16.031], [-20.555, -10.389]],
                  c: true
                }]
              }],
              ix: 2
            },
            nm: 'Path 3',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0.980392217636, 0.972549080849, 0.960784375668, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }, {
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 1,
              k: [{
                i: {
                  x: 0,
                  y: 1
                },
                o: {
                  x: 0.75,
                  y: 0
                },
                t: 55,
                s: [{
                  i: [[0, 0], [-1.826, 0], [0, 0], [0, 0], [0, -1.826], [0, 0], [6.466, -9.652], [0.525, -5.58], [-2.064, -3.135], [1.826, 0], [0, 0], [-1.004, 1.525], [-6.402, 0.88], [2.784, 5.531], [0, 0]],
                  o: [[0, -1.826], [0, 0], [0, 0], [1.826, 0], [0, 0], [0, 0], [-2.784, 5.531], [6.402, 0.88], [1.004, 1.525], [0, 0], [-1.826, 0], [2.064, -3.135], [-0.525, -5.58], [-7.436, -12.755], [0, 0]],
                  v: [[-20.555, -20.306], [-17.25, -23.611], [-0.379, -23.611], [15.806, -23.611], [19.111, -20.306], [19.111, -10.389], [10.258, 16.031], [4.548, 32.937], [18.121, 39.397], [15.806, 42.5], [-17.25, 42.5], [-19.565, 39.397], [-5.992, 32.937], [-11.702, 16.031], [-20.555, -10.389]],
                  c: true
                }]
              }, {
                i: {
                  x: 0.25,
                  y: 1
                },
                o: {
                  x: 0.81,
                  y: 0
                },
                t: 66,
                s: [{
                  i: [[0, 0], [-1.826, 0], [0, 0], [0, 0], [0, -1.826], [0, 0], [6.466, -9.652], [0.525, -5.58], [-2.064, -3.135], [1.826, 0], [0, 0], [-1.004, 1.525], [-6.402, 0.88], [2.784, 5.531], [0, 0]],
                  o: [[0, -1.826], [0, 0], [0, 0], [1.826, 0], [0, 0], [0, 0], [-2.784, 5.531], [6.402, 0.88], [1.004, 1.525], [0, 0], [-1.826, 0], [2.064, -3.135], [-0.525, -5.58], [-7.436, -12.755], [0, 0]],
                  v: [[-18.831, -20.306], [-15.525, -23.611], [-0.517, -23.266], [14.082, -23.611], [17.387, -20.306], [17.387, -10.389], [8.534, 16.031], [2.824, 32.937], [17.949, 39.31], [15.634, 42.414], [-17.077, 42.414], [-19.392, 39.31], [-4.268, 32.937], [-9.977, 16.031], [-18.831, -10.389]],
                  c: true
                }]
              }, {
                i: {
                  x: 0,
                  y: 1
                },
                o: {
                  x: 0.75,
                  y: 0
                },
                t: 74,
                s: [{
                  i: [[0, 0], [-1.826, 0], [0, 0], [0, 0], [0, -1.826], [0, 0], [6.466, -9.652], [0.525, -5.58], [-2.064, -3.135], [1.826, 0], [0, 0], [-1.004, 1.525], [-6.402, 0.88], [2.784, 5.531], [0, 0]],
                  o: [[0, -1.826], [0, 0], [0, 0], [1.826, 0], [0, 0], [0, 0], [-2.784, 5.531], [6.402, 0.88], [1.004, 1.525], [0, 0], [-1.826, 0], [2.064, -3.135], [-0.525, -5.58], [-7.436, -12.755], [0, 0]],
                  v: [[-18.831, -20.306], [-15.525, -23.611], [-0.517, -23.266], [14.082, -23.611], [17.387, -20.306], [17.387, -10.389], [8.534, 16.031], [2.824, 32.937], [17.949, 39.31], [15.634, 42.414], [-17.077, 42.414], [-19.392, 39.31], [-4.268, 32.937], [-9.977, 16.031], [-18.831, -10.389]],
                  c: true
                }]
              }, {
                t: 85,
                s: [{
                  i: [[0, 0], [-1.826, 0], [0, 0], [0, 0], [0, -1.826], [0, 0], [6.466, -9.652], [0.525, -5.58], [-2.064, -3.135], [1.826, 0], [0, 0], [-1.004, 1.525], [-6.402, 0.88], [2.784, 5.531], [0, 0]],
                  o: [[0, -1.826], [0, 0], [0, 0], [1.826, 0], [0, 0], [0, 0], [-2.784, 5.531], [6.402, 0.88], [1.004, 1.525], [0, 0], [-1.826, 0], [2.064, -3.135], [-0.525, -5.58], [-7.436, -12.755], [0, 0]],
                  v: [[-20.555, -20.306], [-17.25, -23.611], [-0.379, -23.611], [15.806, -23.611], [19.111, -20.306], [19.111, -10.389], [10.258, 16.031], [4.548, 32.937], [18.121, 39.397], [15.806, 42.5], [-17.25, 42.5], [-19.565, 39.397], [-5.992, 32.937], [-11.702, 16.031], [-20.555, -10.389]],
                  c: true
                }]
              }],
              ix: 2
            },
            nm: 'Path 3',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.188235297799, 0.529411792755, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 2',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: -59,
        op: 280,
        st: -59,
        bm: 0
      }, {
        ddd: 0,
        ind: 10,
        ty: 4,
        nm: 'Layer 1',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [98.936, 91.773, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [147.32, 147.32, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-20.864, 0], [0, -20.864], [20.864, 0], [0, 20.864]],
                o: [[20.864, 0], [0, 20.864], [-20.864, 0], [0, -20.864]],
                v: [[0, -37.778], [37.778, 0], [0, 37.778], [-37.778, 0]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.439215686275, 0.878431372549, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: -59,
        op: 280,
        st: -59,
        bm: 0
      }],
      markers: []
    },
    "data-ppui": "true"
  }));
};
var CollectDonationsPictogram = function (props) {
  var componentProps = _objectSpread$1({
    'aria-label': 'collect-donations'
  }, props);

  return /*#__PURE__*/React.createElement(LottieContainer, _extends({}, componentProps, {
    animationData: {
      v: '4.8.0',
      meta: {
        g: 'LottieFiles AE 3.1.1',
        a: '',
        k: '',
        d: '',
        tc: ''
      },
      fr: 25,
      ip: 0,
      op: 251,
      w: 200,
      h: 200,
      nm: '004 Collect Donations - Revolve',
      ddd: 1,
      assets: [],
      layers: [{
        ddd: 0,
        ind: 2,
        ty: 3,
        nm: 'NULL CONTROL',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 0,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [100, 98.73, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [60, 60, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [114.3, 114.3, 100],
            ix: 6
          }
        },
        ao: 0,
        ip: 0,
        op: 126,
        st: 0,
        bm: 0
      }, {
        ddd: 0,
        ind: 3,
        ty: 3,
        nm: 'Null 1027',
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 0,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [60, 60, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [50, 50, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [130, 130, 100],
            ix: 6
          }
        },
        ao: 0,
        ip: 0,
        op: 126,
        st: 0,
        bm: 0
      }, {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: 'Layer 8',
        parent: 7,
        td: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [0, 0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.209, 0], [0, 0], [0, -2.209], [0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0]],
                o: [[0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0], [-2.209, 0], [0, 0], [0, -2.209]],
                v: [[-29.056, -21.25], [29.056, -21.25], [33.056, -17.25], [33.056, 17.25], [29.056, 21.25], [-29.056, 21.25], [-33.056, 17.25], [-33.056, -17.25]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0.35686275363, 0.733333349228, 0.988235294819, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }, {
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.209, 0], [0, 0], [0, -2.209], [0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0]],
                o: [[0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0], [-2.209, 0], [0, 0], [0, -2.209]],
                v: [[-38.5, -7.083], [38.5, -7.083], [42.5, -3.083], [42.5, 3.083], [38.5, 7.083], [-38.5, 7.083], [-42.5, 3.083], [-42.5, -3.083]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, -14],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 2',
          np: 1,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 267,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 5,
        ty: 4,
        nm: 'Layer 6',
        parent: 8,
        tt: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Layer 1').transform.opacity;"
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7
          },
          p: {
            a: 0,
            k: [0, 0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-0.066, 0.161], [-11.244, 0], [6.647, -15.338], [7.343, 0], [6.023, 13.902], [-13.809, 0], [-0.885, -2.141]],
                o: [[0.885, -2.141], [13.809, 0], [-5.986, 13.94], [-7.343, 0], [-6.647, -15.338], [11.241, 0], [0.066, 0.161]],
                v: [[0.18, -19.127], [15.976, -28.333], [30.593, 1.889], [0, 28.333], [-30.593, 1.889], [-15.976, -28.333], [-0.18, -19.127]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [1, 1, 1, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 267,
        st: 0,
        bm: 0
      }, {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: 'Layer 5',
        parent: 7,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [-0.003, 6.788, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[0, 0], [0.552, 0], [0, 0], [0, 0.552], [0, 0], [-0.552, 0], [0, 0], [0, -0.552]],
                o: [[0, 0.552], [0, 0], [-0.552, 0], [0, 0], [0, -0.552], [0, 0], [0.552, 0], [0, 0]],
                v: [[18.889, 1.066], [17.889, 2.066], [-17.889, 2.066], [-18.889, 1.066], [-18.889, -1.066], [-17.889, -2.066], [17.889, -2.066], [18.889, -1.066]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.109803922474, 0.392156869173, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 267,
        st: 0,
        bm: 0
      }, {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: 'Layer 2',
        parent: 3,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [53.366, 71.25, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.209, 0], [0, 0], [0, -2.209], [0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0]],
                o: [[0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0], [-2.209, 0], [0, 0], [0, -2.209]],
                v: [[-29.056, -21.25], [29.056, -21.25], [33.056, -17.25], [33.056, 17.25], [29.056, 21.25], [-29.056, 21.25], [-33.056, 17.25], [-33.056, -17.25]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }, {
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.209, 0], [0, 0], [0, -2.209], [0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0]],
                o: [[0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0], [-2.209, 0], [0, 0], [0, -2.209]],
                v: [[-38.5, -7.083], [38.5, -7.083], [42.5, -3.083], [42.5, 3.083], [38.5, 7.083], [-38.5, 7.083], [-42.5, 3.083], [-42.5, -3.083]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, -14.156],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 2',
          np: 1,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false
        }, {
          ty: 'fl',
          c: {
            a: 0,
            k: [0.35686275363, 0.733333349228, 0.988235294819, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }],
        ip: 0,
        op: 267,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 8,
        ty: 4,
        nm: 'Layer 1',
        parent: 3,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 1,
            k: [{
              i: {
                x: [0.833],
                y: [1]
              },
              o: {
                x: [0.75],
                y: [0]
              },
              t: 65,
              s: [15]
            }, {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0]
              },
              t: 69,
              s: [-76]
            }, {
              t: 80,
              s: [15]
            }],
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 358.027, 0],
            ix: 7
          },
          p: {
            a: 1,
            k: [{
              i: {
                x: 0.833,
                y: 0.111
              },
              o: {
                x: 0.75,
                y: 0
              },
              t: 65,
              s: [54.6, 66, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            }, {
              i: {
                x: 0,
                y: 1
              },
              o: {
                x: 0.167,
                y: 0.129
              },
              t: 69,
              s: [54.6, 66.667, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            }, {
              i: {
                x: 0.25,
                y: 0.25
              },
              o: {
                x: 1,
                y: 1
              },
              t: 80,
              s: [54.6, 54, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            }, {
              i: {
                x: 0,
                y: 1
              },
              o: {
                x: 0.75,
                y: 0
              },
              t: 84,
              s: [54.6, 54, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            }, {
              t: 95,
              s: [54.61, 66, 0]
            }],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 28.333, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [101.043, 100, 98.968],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-0.066, 0.161], [-11.244, 0], [6.647, -15.338], [7.343, 0], [6.023, 13.902], [-13.809, 0], [-0.885, -2.141]],
                o: [[0.885, -2.141], [13.809, 0], [-5.986, 13.94], [-7.343, 0], [-6.647, -15.338], [11.241, 0], [0.066, 0.161]],
                v: [[0.18, -19.127], [15.976, -28.333], [30.593, 1.889], [0, 28.333], [-30.593, 1.889], [-15.976, -28.333], [-0.18, -19.127]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [1, 0.611764729023, 0.666666686535, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 267,
        st: 0,
        bm: 0
      }],
      markers: []
    },
    "data-ppui": "true"
  }));
};
var DiscountsPictogram = function (props) {
  var componentProps = _objectSpread$1({
    'aria-label': 'discounts'
  }, props);

  return /*#__PURE__*/React.createElement(LottieContainer, _extends({}, componentProps, {
    animationData: {
      v: '5.9.0',
      fr: 25,
      ip: 0,
      op: 251,
      w: 200,
      h: 200,
      nm: '014 Discounts - Glide 2',
      ddd: 0,
      assets: [{
        id: 'comp_0',
        nm: '014 Discounts - Glide',
        fr: 25,
        layers: [{
          ddd: 0,
          ind: 1,
          ty: 3,
          nm: 'Null 1254',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 0,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [100, 100, 0],
              ix: 2,
              l: 2
            },
            a: {
              a: 0,
              k: [50, 50, 0],
              ix: 1,
              l: 2
            },
            s: {
              a: 0,
              k: [127, 127, 100],
              ix: 6,
              l: 2
            }
          },
          ao: 0,
          ip: 0,
          op: 251,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'Layer 13',
          parent: 8,
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [0.5, -23.919, 0],
              ix: 2,
              l: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1,
              l: 2
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6,
              l: 2
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[-2.209, 0], [0, -2.209], [2.209, 0], [0, 2.209]],
                  o: [[2.209, 0], [0, 2.209], [-2.209, 0], [0, -2.209]],
                  v: [[0, -4], [4, 0], [0, 4], [-4, 0]],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.980392158031, 0.972549021244, 0.960784316063, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }],
          ip: 0,
          op: 251,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: 'Layer 12',
          parent: 8,
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [-7.793, -0.083, 0],
              ix: 2,
              l: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1,
              l: 2
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6,
              l: 2
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[-2.209, 0], [0, 2.209], [2.209, 0], [0, -2.209]],
                  o: [[2.209, 0], [0, -2.209], [-2.209, 0], [0, 2.209]],
                  v: [[0, 4], [4, 0], [0, -4], [-4, 0]],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [0, 0.109803922474, 0.392156869173, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }],
          ip: 0,
          op: 251,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 5,
          ty: 4,
          nm: 'Layer 11',
          parent: 8,
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [8.25, 15.874, 0],
              ix: 2,
              l: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1,
              l: 2
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6,
              l: 2
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[-2.209, 0], [0, 2.209], [2.209, 0], [0, -2.209]],
                  o: [[2.209, 0], [0, -2.209], [-2.209, 0], [0, 2.209]],
                  v: [[0, 4], [4, 0], [0, -4], [-4, 0]],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [0, 0.109803922474, 0.392156869173, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }],
          ip: 0,
          op: 251,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 6,
          ty: 4,
          nm: 'Layer 10',
          parent: 8,
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [0, 7.831, 0],
              ix: 2,
              l: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1,
              l: 2
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6,
              l: 2
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0.391, -0.391], [0, 0], [-0.391, -0.391], [0, 0], [-0.391, 0.391], [0, 0], [0.391, 0.391], [0, 0]],
                  o: [[0, 0], [-0.391, 0.391], [0, 0], [0.391, 0.391], [0, 0], [0.391, -0.391], [0, 0], [-0.391, -0.391]],
                  v: [[8.775, -11.25], [-11.25, 8.775], [-11.25, 10.189], [-10.189, 11.25], [-8.775, 11.25], [11.25, -8.775], [11.25, -10.189], [10.189, -11.25]],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [0, 0.109803922474, 0.392156869173, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }],
          ip: 0,
          op: 251,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 7,
          ty: 4,
          nm: 'Layer 7',
          parent: 8,
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [0.5, 7.809, 0],
              ix: 2,
              l: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1,
              l: 2
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6,
              l: 2
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[-11.046, 0], [0, -11.046], [11.046, 0], [0, 11.046]],
                  o: [[11.046, 0], [0, 11.046], [-11.046, 0], [0, -11.046]],
                  v: [[0, -20], [20, 0], [0, 20], [-20, 0]],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.980392158031, 0.972549021244, 0.960784316063, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }],
          ip: 0,
          op: 251,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 8,
          ty: 4,
          nm: 'Layer 1',
          parent: 1,
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [1.096]
                },
                o: {
                  x: [0.75],
                  y: [0]
                },
                t: 87,
                s: [0]
              }, {
                i: {
                  x: [0.833],
                  y: [0.965]
                },
                o: {
                  x: [0.167],
                  y: [0.035]
                },
                t: 98,
                s: [-12]
              }, {
                i: {
                  x: [0],
                  y: [1]
                },
                o: {
                  x: [0.167],
                  y: [-0.096]
                },
                t: 106,
                s: [12]
              }, {
                t: 117,
                s: [0]
              }],
              ix: 10
            },
            p: {
              a: 0,
              k: [49.929, 18.727, 0],
              ix: 2,
              l: 2
            },
            a: {
              a: 0,
              k: [0, -24.231, 0],
              ix: 1,
              l: 2
            },
            s: {
              a: 0,
              k: [135.2, 135.2, 100],
              ix: 6,
              l: 2
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 2.209], [0, 0], [-1.131, 0.739], [0, 0], [-0.665, -0.434], [0, 0], [0, -1.351], [0, 0], [2.209, 0], [0, 0]],
                  o: [[0, 0], [0, -1.351], [0, 0], [0.665, -0.434], [0, 0], [1.131, 0.739], [0, 0], [0, 2.209], [0, 0], [-2.209, 0]],
                  v: [[-28, 31.806], [-28, -15.743], [-26.187, -19.093], [-1.094, -35.48], [1.094, -35.48], [26.187, -19.093], [28, -15.743], [28, 31.806], [24, 35.806], [-24, 35.806]],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.35686275363, 0.733333349228, 0.988235294819, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }],
          ip: 0,
          op: 251,
          st: 0,
          bm: 0
        }]
      }],
      layers: [{
        ddd: 0,
        ind: 1,
        ty: 0,
        nm: '014 Discounts - Glide',
        refId: 'comp_0',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [100, 100, 0],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [100, 100, 0],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [125, 125, 100],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        w: 200,
        h: 200,
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }],
      markers: []
    },
    "data-ppui": "true"
  }));
};
var EarnCashBackPictogram = function (props) {
  var componentProps = _objectSpread$1({
    'aria-label': 'earn-cash-back'
  }, props);

  return /*#__PURE__*/React.createElement(LottieContainer, _extends({}, componentProps, {
    animationData: {
      v: '4.8.0',
      meta: {
        g: 'LottieFiles AE 3.1.1',
        a: '',
        k: '',
        d: '',
        tc: ''
      },
      fr: 25,
      ip: 0,
      op: 251,
      w: 200,
      h: 200,
      nm: '005 Earn Cashback - Revolve',
      ddd: 1,
      assets: [],
      layers: [{
        ddd: 1,
        ind: 2,
        ty: 4,
        nm: 'Layer 12',
        parent: 13,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7
          },
          p: {
            a: 1,
            k: [{
              i: {
                x: 0.667,
                y: 1
              },
              o: {
                x: 0.333,
                y: 0
              },
              t: 46,
              s: [-38.263, -25.25, 0],
              to: [6.377, 0, 0],
              ti: [-6.377, 0, 0]
            }, {
              t: 56,
              s: [-0.002, -25.25, 0]
            }],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 1.312, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6,
            x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
          }
        },
        ao: 0,
        ef: [{
          ty: 28,
          nm: 'Set Matte',
          np: 8,
          mn: 'ADBE Set Matte3',
          ix: 1,
          en: 1,
          ef: [{
            ty: 10,
            nm: 'Take Matte From Layer',
            mn: 'ADBE Set Matte3-0001',
            ix: 1,
            v: {
              a: 0,
              k: 9,
              ix: 1
            }
          }, {
            ty: 7,
            nm: 'Use For Matte',
            mn: 'ADBE Set Matte3-0002',
            ix: 2,
            v: {
              a: 0,
              k: 4,
              ix: 2
            }
          }, {
            ty: 7,
            nm: 'Invert Matte',
            mn: 'ADBE Set Matte3-0003',
            ix: 3,
            v: {
              a: 0,
              k: 0,
              ix: 3
            }
          }, {
            ty: 7,
            nm: 'If Layer Sizes Differ',
            mn: 'ADBE Set Matte3-0004',
            ix: 4,
            v: {
              a: 0,
              k: 1,
              ix: 4
            }
          }, {
            ty: 7,
            nm: 'Composite Matte with Original',
            mn: 'ADBE Set Matte3-0005',
            ix: 5,
            v: {
              a: 0,
              k: 1,
              ix: 5
            }
          }, {
            ty: 7,
            nm: 'Premultiply Matte Layer',
            mn: 'ADBE Set Matte3-0006',
            ix: 6,
            v: {
              a: 0,
              k: 1,
              ix: 6
            }
          }]
        }],
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[0, 0], [0, 0], [-0.131, -0.094], [-0.161, -0.025], [0, 0], [-0.166, -0.194], [0.012, -0.254], [0.185, -0.162], [0, 0], [0.051, -0.152], [-0.025, -0.158], [0, 0], [0.149, -0.218], [0.261, -0.053], [0.194, 0.099], [0, 0], [0.163, 0], [0.145, -0.074], [0, 0], [0.253, 0.079], [0.126, 0.23], [-0.035, 0.213], [0, 0], [0.051, 0.152], [0.116, 0.112], [0, 0], [0, 0.26], [-0.184, 0.187], [-0.204, 0.027], [0, 0], [-0.133, 0.094], [-0.074, 0.144], [0, 0], [-0.169, 0.113], [-0.204, 0], [-0.169, -0.113], [-0.075, -0.187]],
                o: [[0, 0], [0.073, 0.143], [0.131, 0.094], [0, 0], [0.256, 0.03], [0.166, 0.194], [-0.017, 0.243], [0, 0], [-0.116, 0.112], [-0.051, 0.152], [0, 0], [0.048, 0.258], [-0.148, 0.218], [-0.216, 0.034], [0, 0], [-0.145, -0.074], [-0.163, 0], [0, 0], [-0.237, 0.117], [-0.253, -0.079], [-0.101, -0.191], [0, 0], [0.025, -0.158], [-0.051, -0.152], [0, 0], [-0.184, -0.187], [0, -0.26], [0.146, -0.143], [0, 0], [0.162, -0.023], [0.133, -0.094], [0, 0], [0.075, -0.187], [0.169, -0.113], [0.204, 0], [0.169, 0.113], [0, 0]],
                v: [[0.943, -9.44], [3.378, -4.419], [3.689, -4.057], [4.132, -3.876], [9.727, -3.073], [10.384, -2.725], [10.624, -2.029], [10.308, -1.396], [6.232, 2.49], [5.976, 2.892], [5.936, 3.364], [6.894, 8.857], [6.737, 9.599], [6.099, 10.022], [5.467, 9.922], [0.474, 7.331], [0.005, 7.218], [-0.464, 7.331], [-5.467, 9.922], [-6.232, 9.982], [-6.823, 9.5], [-6.925, 8.877], [-5.967, 3.384], [-6.007, 2.912], [-6.262, 2.51], [-10.339, -1.376], [-10.625, -2.074], [-10.339, -2.772], [-9.799, -3.033], [-4.204, -3.836], [-3.754, -4.015], [-3.439, -4.379], [-0.953, -9.4], [-0.578, -9.861], [-0.005, -10.035], [0.568, -9.861], [0.943, -9.4]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.109803922474, 0.392156869173, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 62,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 3,
        ty: 4,
        nm: 'Layer 11',
        parent: 13,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 1,
            k: [{
              i: {
                x: [0.667],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 53,
              s: [0]
            }, {
              t: 62,
              s: [213]
            }],
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7
          },
          p: {
            a: 1,
            k: [{
              i: {
                x: 0.667,
                y: 1
              },
              o: {
                x: 0.333,
                y: 0
              },
              t: 46,
              s: [-38.263, -25.25, 0],
              to: [6.377, 0, 0],
              ti: [-6.377, 0, 0]
            }, {
              t: 56,
              s: [-0.002, -25.25, 0]
            }],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 1.312, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6,
            x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
          }
        },
        ao: 0,
        ef: [{
          ty: 28,
          nm: 'Set Matte',
          np: 8,
          mn: 'ADBE Set Matte3',
          ix: 1,
          en: 1,
          ef: [{
            ty: 10,
            nm: 'Take Matte From Layer',
            mn: 'ADBE Set Matte3-0001',
            ix: 1,
            v: {
              a: 0,
              k: 9,
              ix: 1
            }
          }, {
            ty: 7,
            nm: 'Use For Matte',
            mn: 'ADBE Set Matte3-0002',
            ix: 2,
            v: {
              a: 0,
              k: 4,
              ix: 2
            }
          }, {
            ty: 7,
            nm: 'Invert Matte',
            mn: 'ADBE Set Matte3-0003',
            ix: 3,
            v: {
              a: 0,
              k: 0,
              ix: 3
            }
          }, {
            ty: 7,
            nm: 'If Layer Sizes Differ',
            mn: 'ADBE Set Matte3-0004',
            ix: 4,
            v: {
              a: 0,
              k: 1,
              ix: 4
            }
          }, {
            ty: 7,
            nm: 'Composite Matte with Original',
            mn: 'ADBE Set Matte3-0005',
            ix: 5,
            v: {
              a: 0,
              k: 1,
              ix: 5
            }
          }, {
            ty: 7,
            nm: 'Premultiply Matte Layer',
            mn: 'ADBE Set Matte3-0006',
            ix: 6,
            v: {
              a: 0,
              k: 1,
              ix: 6
            }
          }]
        }],
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[0, 0], [0, 0], [-0.131, -0.094], [-0.161, -0.025], [0, 0], [-0.166, -0.194], [0.012, -0.254], [0.185, -0.162], [0, 0], [0.051, -0.152], [-0.025, -0.158], [0, 0], [0.149, -0.218], [0.261, -0.053], [0.194, 0.099], [0, 0], [0.163, 0], [0.145, -0.074], [0, 0], [0.253, 0.079], [0.126, 0.23], [-0.035, 0.213], [0, 0], [0.051, 0.152], [0.116, 0.112], [0, 0], [0, 0.26], [-0.184, 0.187], [-0.204, 0.027], [0, 0], [-0.133, 0.094], [-0.074, 0.144], [0, 0], [-0.169, 0.113], [-0.204, 0], [-0.169, -0.113], [-0.075, -0.187]],
                o: [[0, 0], [0.073, 0.143], [0.131, 0.094], [0, 0], [0.256, 0.03], [0.166, 0.194], [-0.017, 0.243], [0, 0], [-0.116, 0.112], [-0.051, 0.152], [0, 0], [0.048, 0.258], [-0.148, 0.218], [-0.216, 0.034], [0, 0], [-0.145, -0.074], [-0.163, 0], [0, 0], [-0.237, 0.117], [-0.253, -0.079], [-0.101, -0.191], [0, 0], [0.025, -0.158], [-0.051, -0.152], [0, 0], [-0.184, -0.187], [0, -0.26], [0.146, -0.143], [0, 0], [0.162, -0.023], [0.133, -0.094], [0, 0], [0.075, -0.187], [0.169, -0.113], [0.204, 0], [0.169, 0.113], [0, 0]],
                v: [[0.943, -9.44], [3.378, -4.419], [3.689, -4.057], [4.132, -3.876], [9.727, -3.073], [10.384, -2.725], [10.624, -2.029], [10.308, -1.396], [6.232, 2.49], [5.976, 2.892], [5.936, 3.364], [6.894, 8.857], [6.737, 9.599], [6.099, 10.022], [5.467, 9.922], [0.474, 7.331], [0.005, 7.218], [-0.464, 7.331], [-5.467, 9.922], [-6.232, 9.982], [-6.823, 9.5], [-6.925, 8.877], [-5.967, 3.384], [-6.007, 2.912], [-6.262, 2.51], [-10.339, -1.376], [-10.625, -2.074], [-10.339, -2.772], [-9.799, -3.033], [-4.204, -3.836], [-3.754, -4.015], [-3.439, -4.379], [-0.953, -9.4], [-0.578, -9.861], [-0.005, -10.035], [0.568, -9.861], [0.943, -9.4]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.109803922474, 0.392156869173, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 46,
        op: 62,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 4,
        ty: 4,
        nm: 'Layer 6',
        parent: 13,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7
          },
          p: {
            a: 1,
            k: [{
              i: {
                x: 0.667,
                y: 1
              },
              o: {
                x: 0.333,
                y: 0
              },
              t: 35,
              s: [-0.002, -25.25, 0],
              to: [6.087, 0, 0],
              ti: [-6.087, 0, 0]
            }, {
              t: 45,
              s: [36.52, -25.25, 0]
            }],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 1.312, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6,
            x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
          }
        },
        ao: 0,
        ef: [{
          ty: 28,
          nm: 'Set Matte',
          np: 8,
          mn: 'ADBE Set Matte3',
          ix: 1,
          en: 1,
          ef: [{
            ty: 10,
            nm: 'Take Matte From Layer',
            mn: 'ADBE Set Matte3-0001',
            ix: 1,
            v: {
              a: 0,
              k: 9,
              ix: 1
            }
          }, {
            ty: 7,
            nm: 'Use For Matte',
            mn: 'ADBE Set Matte3-0002',
            ix: 2,
            v: {
              a: 0,
              k: 4,
              ix: 2
            }
          }, {
            ty: 7,
            nm: 'Invert Matte',
            mn: 'ADBE Set Matte3-0003',
            ix: 3,
            v: {
              a: 0,
              k: 0,
              ix: 3
            }
          }, {
            ty: 7,
            nm: 'If Layer Sizes Differ',
            mn: 'ADBE Set Matte3-0004',
            ix: 4,
            v: {
              a: 0,
              k: 1,
              ix: 4
            }
          }, {
            ty: 7,
            nm: 'Composite Matte with Original',
            mn: 'ADBE Set Matte3-0005',
            ix: 5,
            v: {
              a: 0,
              k: 1,
              ix: 5
            }
          }, {
            ty: 7,
            nm: 'Premultiply Matte Layer',
            mn: 'ADBE Set Matte3-0006',
            ix: 6,
            v: {
              a: 0,
              k: 1,
              ix: 6
            }
          }]
        }],
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[0, 0], [0, 0], [-0.131, -0.094], [-0.161, -0.025], [0, 0], [-0.166, -0.194], [0.012, -0.254], [0.185, -0.162], [0, 0], [0.051, -0.152], [-0.025, -0.158], [0, 0], [0.149, -0.218], [0.261, -0.053], [0.194, 0.099], [0, 0], [0.163, 0], [0.145, -0.074], [0, 0], [0.253, 0.079], [0.126, 0.23], [-0.035, 0.213], [0, 0], [0.051, 0.152], [0.116, 0.112], [0, 0], [0, 0.26], [-0.184, 0.187], [-0.204, 0.027], [0, 0], [-0.133, 0.094], [-0.074, 0.144], [0, 0], [-0.169, 0.113], [-0.204, 0], [-0.169, -0.113], [-0.075, -0.187]],
                o: [[0, 0], [0.073, 0.143], [0.131, 0.094], [0, 0], [0.256, 0.03], [0.166, 0.194], [-0.017, 0.243], [0, 0], [-0.116, 0.112], [-0.051, 0.152], [0, 0], [0.048, 0.258], [-0.148, 0.218], [-0.216, 0.034], [0, 0], [-0.145, -0.074], [-0.163, 0], [0, 0], [-0.237, 0.117], [-0.253, -0.079], [-0.101, -0.191], [0, 0], [0.025, -0.158], [-0.051, -0.152], [0, 0], [-0.184, -0.187], [0, -0.26], [0.146, -0.143], [0, 0], [0.162, -0.023], [0.133, -0.094], [0, 0], [0.075, -0.187], [0.169, -0.113], [0.204, 0], [0.169, 0.113], [0, 0]],
                v: [[0.943, -9.44], [3.378, -4.419], [3.689, -4.057], [4.132, -3.876], [9.727, -3.073], [10.384, -2.725], [10.624, -2.029], [10.308, -1.396], [6.232, 2.49], [5.976, 2.892], [5.936, 3.364], [6.894, 8.857], [6.737, 9.599], [6.099, 10.022], [5.467, 9.922], [0.474, 7.331], [0.005, 7.218], [-0.464, 7.331], [-5.467, 9.922], [-6.232, 9.982], [-6.823, 9.5], [-6.925, 8.877], [-5.967, 3.384], [-6.007, 2.912], [-6.262, 2.51], [-10.339, -1.376], [-10.625, -2.074], [-10.339, -2.772], [-9.799, -3.033], [-4.204, -3.836], [-3.754, -4.015], [-3.439, -4.379], [-0.953, -9.4], [-0.578, -9.861], [-0.005, -10.035], [0.568, -9.861], [0.943, -9.4]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.109803922474, 0.392156869173, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 45,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 5,
        ty: 4,
        nm: 'Layer 10',
        parent: 13,
        td: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7
          },
          p: {
            a: 0,
            k: [0, 0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.209, 0], [0, 0], [0, -2.209], [0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0]],
                o: [[0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0], [-2.209, 0], [0, 0], [0, -2.209]],
                v: [[-19.611, -42.5], [19.611, -42.5], [23.611, -38.5], [23.611, 38.5], [19.611, 42.5], [-19.611, 42.5], [-23.611, 38.5], [-23.611, -38.5]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0.35686275363, 0.733333349228, 0.988235294819, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 6,
        ty: 4,
        nm: 'Layer 8',
        parent: 11,
        tt: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Layer 2').transform.opacity;"
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8,
            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Layer 4').transform.xRotation;"
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7,
            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Layer 4').transform.orientation;"
          },
          p: {
            a: 0,
            k: [0, 0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        ef: [{
          ty: 28,
          nm: 'Set Matte',
          np: 8,
          mn: 'ADBE Set Matte3',
          ix: 1,
          en: 1,
          ef: [{
            ty: 10,
            nm: 'Take Matte From Layer',
            mn: 'ADBE Set Matte3-0001',
            ix: 1,
            v: {
              a: 0,
              k: 12,
              ix: 1
            }
          }, {
            ty: 7,
            nm: 'Use For Matte',
            mn: 'ADBE Set Matte3-0002',
            ix: 2,
            v: {
              a: 0,
              k: 4,
              ix: 2
            }
          }, {
            ty: 7,
            nm: 'Invert Matte',
            mn: 'ADBE Set Matte3-0003',
            ix: 3,
            v: {
              a: 0,
              k: 0,
              ix: 3
            }
          }, {
            ty: 7,
            nm: 'If Layer Sizes Differ',
            mn: 'ADBE Set Matte3-0004',
            ix: 4,
            v: {
              a: 0,
              k: 1,
              ix: 4
            }
          }, {
            ty: 7,
            nm: 'Composite Matte with Original',
            mn: 'ADBE Set Matte3-0005',
            ix: 5,
            v: {
              a: 0,
              k: 1,
              ix: 5
            }
          }, {
            ty: 7,
            nm: 'Premultiply Matte Layer',
            mn: 'ADBE Set Matte3-0006',
            ix: 6,
            v: {
              a: 0,
              k: 1,
              ix: 6
            }
          }]
        }],
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-9.128, 0], [0, -9.128], [9.128, 0], [0, 9.128]],
                o: [[9.128, 0], [0, 9.128], [-9.128, 0], [0, -9.128]],
                v: [[0, -16.528], [16.528, 0], [0, 16.528], [-16.528, 0]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.109803929925, 0.392156898975, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 7,
        ty: 4,
        nm: 'Layer 13',
        parent: 12,
        tt: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Layer 2').transform.opacity;"
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7
          },
          p: {
            a: 0,
            k: [-0.75, 0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        ef: [{
          ty: 28,
          nm: 'Set Matte',
          np: 8,
          mn: 'ADBE Set Matte3',
          ix: 1,
          en: 1,
          ef: [{
            ty: 10,
            nm: 'Take Matte From Layer',
            mn: 'ADBE Set Matte3-0001',
            ix: 1,
            v: {
              a: 0,
              k: 12,
              ix: 1
            }
          }, {
            ty: 7,
            nm: 'Use For Matte',
            mn: 'ADBE Set Matte3-0002',
            ix: 2,
            v: {
              a: 0,
              k: 4,
              ix: 2
            }
          }, {
            ty: 7,
            nm: 'Invert Matte',
            mn: 'ADBE Set Matte3-0003',
            ix: 3,
            v: {
              a: 0,
              k: 0,
              ix: 3
            }
          }, {
            ty: 7,
            nm: 'If Layer Sizes Differ',
            mn: 'ADBE Set Matte3-0004',
            ix: 4,
            v: {
              a: 0,
              k: 1,
              ix: 4
            }
          }, {
            ty: 7,
            nm: 'Composite Matte with Original',
            mn: 'ADBE Set Matte3-0005',
            ix: 5,
            v: {
              a: 0,
              k: 1,
              ix: 5
            }
          }, {
            ty: 7,
            nm: 'Premultiply Matte Layer',
            mn: 'ADBE Set Matte3-0006',
            ix: 6,
            v: {
              a: 0,
              k: 1,
              ix: 6
            }
          }]
        }],
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-9.128, 0], [0, -9.128], [9.128, 0], [0, 9.128]],
                o: [[9.128, 0], [0, 9.128], [-9.128, 0], [0, -9.128]],
                v: [[0, -16.528], [16.528, 0], [0, 16.528], [-16.528, 0]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.329411774874, 0, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 9,
        ty: 4,
        nm: 'Layer 9',
        parent: 13,
        td: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7
          },
          p: {
            a: 0,
            k: [0, 0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.209, 0], [0, 0], [0, -2.209], [0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0]],
                o: [[0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0], [-2.209, 0], [0, 0], [0, -2.209]],
                v: [[-19.611, -42.5], [19.611, -42.5], [23.611, -38.5], [23.611, 38.5], [19.611, 42.5], [-19.611, 42.5], [-23.611, 38.5], [-23.611, -38.5]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0.35686275363, 0.733333349228, 0.988235294819, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 10,
        ty: 4,
        nm: 'Layer 7',
        parent: 12,
        tt: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Layer 2').transform.opacity;"
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8,
            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Layer 2').transform.xRotation;"
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7,
            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Layer 2').transform.orientation;"
          },
          p: {
            a: 0,
            k: [0, 0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.209, 0], [0, 0], [0, -2.209], [0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0]],
                o: [[0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0], [-2.209, 0], [0, 0], [0, -2.209]],
                v: [[-33.778, -21.25], [33.778, -21.25], [37.778, -17.25], [37.778, 17.25], [33.778, 21.25], [-33.778, 21.25], [-37.778, 17.25], [-37.778, -17.25]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0.980392217636, 0.972549080849, 0.960784375668, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 11,
        ty: 4,
        nm: 'Layer 4',
        parent: 12,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Layer 2').transform.opacity;"
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7
          },
          p: {
            a: 0,
            k: [-0.75, 0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        ef: [{
          ty: 28,
          nm: 'Set Matte',
          np: 8,
          mn: 'ADBE Set Matte3',
          ix: 1,
          en: 1,
          ef: [{
            ty: 10,
            nm: 'Take Matte From Layer',
            mn: 'ADBE Set Matte3-0001',
            ix: 1,
            v: {
              a: 0,
              k: 12,
              ix: 1
            }
          }, {
            ty: 7,
            nm: 'Use For Matte',
            mn: 'ADBE Set Matte3-0002',
            ix: 2,
            v: {
              a: 0,
              k: 4,
              ix: 2
            }
          }, {
            ty: 7,
            nm: 'Invert Matte',
            mn: 'ADBE Set Matte3-0003',
            ix: 3,
            v: {
              a: 0,
              k: 0,
              ix: 3
            }
          }, {
            ty: 7,
            nm: 'If Layer Sizes Differ',
            mn: 'ADBE Set Matte3-0004',
            ix: 4,
            v: {
              a: 0,
              k: 1,
              ix: 4
            }
          }, {
            ty: 7,
            nm: 'Composite Matte with Original',
            mn: 'ADBE Set Matte3-0005',
            ix: 5,
            v: {
              a: 0,
              k: 1,
              ix: 5
            }
          }, {
            ty: 7,
            nm: 'Premultiply Matte Layer',
            mn: 'ADBE Set Matte3-0006',
            ix: 6,
            v: {
              a: 0,
              k: 1,
              ix: 6
            }
          }]
        }],
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-9.128, 0], [0, -9.128], [9.128, 0], [0, 9.128]],
                o: [[9.128, 0], [0, 9.128], [-9.128, 0], [0, -9.128]],
                v: [[0, -16.528], [16.528, 0], [0, 16.528], [-16.528, 0]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0, 0.329411774874, 0, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 12,
        ty: 4,
        nm: 'Layer 2',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7
          },
          p: {
            a: 1,
            k: [{
              i: {
                x: 0.16,
                y: 1
              },
              o: {
                x: 0.84,
                y: 0
              },
              t: 18,
              s: [127.028, 112.416, 0],
              to: [3.493, 0, 0],
              ti: [-3.493, 0, 0]
            }, {
              i: {
                x: 0.16,
                y: 0.16
              },
              o: {
                x: 0.84,
                y: 0.84
              },
              t: 29,
              s: [147.983, 112.416, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            }, {
              i: {
                x: 0.16,
                y: 1
              },
              o: {
                x: 0.84,
                y: 0
              },
              t: 37,
              s: [147.983, 112.416, 0],
              to: [-3.492, 0, 0],
              ti: [3.492, 0, 0]
            }, {
              t: 48,
              s: [127.028, 112.416, 0]
            }],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 1,
            k: [{
              i: {
                x: [0.833, 0.833, 0.833],
                y: [1, 1, 1]
              },
              o: {
                x: [0.75, 0.75, 0.75],
                y: [0, 0, 0]
              },
              t: 20,
              s: [146.05, 146.05, 146.05]
            }, {
              i: {
                x: [0.25, 0.25, 0.25],
                y: [1, 1, 1]
              },
              o: {
                x: [0.167, 0.167, 0.167],
                y: [0, 0, 0]
              },
              t: 26,
              s: [146.05, 3.81, 146.05]
            }, {
              t: 32,
              s: [146.05, 146.05, 146.05]
            }],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.209, 0], [0, 0], [0, -2.209], [0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0]],
                o: [[0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0], [-2.209, 0], [0, 0], [0, -2.209]],
                v: [[-33.778, -21.25], [33.778, -21.25], [37.778, -17.25], [37.778, 17.25], [33.778, 21.25], [-33.778, 21.25], [-37.778, 17.25], [-37.778, -17.25]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0.435294121504, 0.768627464771, 0, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 1,
        ind: 13,
        ty: 4,
        nm: 'Layer 1',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [0, 0, 0],
            ix: 7
          },
          p: {
            a: 0,
            k: [92.542, 95.174, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [146.05, 146.05, 146.05],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.209, 0], [0, 0], [0, -2.209], [0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0]],
                o: [[0, 0], [2.209, 0], [0, 0], [0, 2.209], [0, 0], [-2.209, 0], [0, 0], [0, -2.209]],
                v: [[-19.611, -42.5], [19.611, -42.5], [23.611, -38.5], [23.611, 38.5], [19.611, 42.5], [-19.611, 42.5], [-23.611, 38.5], [-23.611, -38.5]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0.35686275363, 0.733333349228, 0.988235294819, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }],
      markers: []
    },
    "data-ppui": "true"
  }));
};
var HighFivePictogram = function (props) {
  var componentProps = _objectSpread$1({
    'aria-label': 'high-five'
  }, props);

  return /*#__PURE__*/React.createElement(LottieContainer, _extends({}, componentProps, {
    animationData: {
      v: '4.8.0',
      meta: {
        g: 'LottieFiles AE 3.3.6',
        a: '',
        k: '',
        d: '',
        tc: ''
      },
      fr: 25,
      ip: 0,
      op: 251,
      w: 200,
      h: 200,
      nm: '007 High Five - Swipe',
      ddd: 0,
      assets: [],
      layers: [{
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: 'Layer 7',
        parent: 4,
        td: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [-55.769, 138.462, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [-55.769, 138.462, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.729, 15.575], [-9.224, 52.024], [-9.888, 3.083], [-7.428, -7.746], [-1.105, 1.533], [-0.666, -1.164], [-2.541, -2.093], [-1.533, 6.031], [-9.445, 0.752], [-4.718, -10.097], [-1.07, -3.904], [-0.861, 2.944], [-11.639, -0.479], [-2.529, -11.05], [0.936, -5.517], [0.675, -3.826], [-0.441, -0.181], [-0.248, 0.573], [-0.358, 0.51], [-8.979, -0.101], [2.865, -16.495], [5.193, -29.353], [0.923, -5.354], [-2.983, 2.919], [-10.023, -9.403], [8.864, -10.23], [2.73, -2.914], [23.265, -25.731], [25.821, -3.708], [20.872, 12.853], [8.452, 21.429], [0.292, 0.438], [0.485, 1.537]],
                o: [[9.12, -52.042], [1.82, -10.264], [10.206, -3.182], [0.31, 0.323], [0.598, 1.203], [1.5, 2.622], [1.157, -6.127], [2.497, -9.823], [11.941, -0.951], [1.256, 2.688], [0.927, -4.14], [3.213, -10.986], [11.401, 0.469], [1.308, 5.715], [-0.65, 3.83], [0.441, 0.181], [0.159, -0.612], [0.245, -0.565], [5.181, -7.392], [16.157, 0.182], [-5.102, 29.369], [-0.947, 5.35], [3.59, -2.657], [9.833, -9.624], [9.762, 9.157], [-2.613, 3.016], [-23.72, 25.32], [-17.447, 19.296], [-24.304, 3.49], [-19.736, -12.153], [-0.292, -0.438], [-0.358, -1.577], [-4.792, -15.17]],
                v: [[-131.085, 39.52], [-103.458, -116.559], [-85.908, -136.995], [-59.298, -129.698], [-57.638, -129.128], [-55.831, -125.526], [-51.759, -117.451], [-48.219, -135.813], [-27.167, -154.025], [-0.858, -139.471], [1.849, -129.959], [4.148, -140.089], [29.463, -157.905], [52.914, -138.229], [52.04, -121.562], [50.019, -110.083], [51.343, -109.54], [51.838, -111.366], [52.828, -112.951], [74.147, -124.085], [98.583, -93.444], [83.013, -5.382], [80.24, 10.68], [89.602, 1.989], [124.802, 1.659], [126.476, 36.519], [118.33, 45.302], [47.277, 121.36], [-16.755, 156.828], [-84.549, 142.622], [-126.292, 91.767], [-127.167, 90.454], [-128.258, 85.728]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0.980392217636, 0.980392217636, 0.980392217636, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: 'Layer 6',
        parent: 5,
        tt: 1,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [63.462, 119.231, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [63.462, 119.231, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[5.771, 14.721], [19.381, 49.152], [10.303, 1.056], [5.74, -9.068], [1.387, 1.282], [0.421, -1.273], [2.074, -2.557], [2.702, 5.606], [9.406, -1.141], [2.616, -10.833], [0.273, -4.039], [1.429, 2.714], [11.312, -2.783], [0.282, -11.332], [-2.014, -5.221], [-1.422, -3.615], [0.397, -0.265], [0.357, 0.512], [0.452, 0.429], [8.779, -1.884], [-6.087, -15.596], [-10.925, -27.735], [-1.969, -5.064], [3.504, 2.268], [7.954, -11.207], [-10.72, -8.263], [-3.255, -2.314], [-27.916, -20.593], [-26.043, 1.499], [-17.901, 16.746], [-4.024, 22.682], [-0.199, 0.487], [-0.17, 1.603]],
                o: [[-19.282, -49.19], [-3.824, -9.698], [-10.634, -1.09], [-0.24, 0.379], [-0.347, 1.298], [-0.949, 2.868], [-2.352, -5.774], [-4.4, -9.131], [-11.892, 1.442], [-0.697, 2.884], [-1.731, -3.873], [-5.333, -10.128], [-11.08, 2.726], [-0.146, 5.861], [1.398, 3.625], [-0.397, 0.265], [-0.277, -0.568], [-0.353, -0.505], [-6.547, -6.215], [-15.798, 3.39], [10.838, 27.769], [1.991, 5.055], [-4.046, -1.89], [-11.549, -7.477], [-7.747, 10.915], [3.161, 2.436], [28.28, 20.1], [20.934, 15.443], [24.513, -1.411], [16.926, -15.834], [0.199, -0.487], [0.037, -1.617], [1.681, -15.82]],
                v: [[127.965, 15.65], [69.864, -131.822], [48.602, -148.362], [23.974, -135.921], [22.46, -135.032], [21.406, -131.143], [19.02, -122.419], [11.9, -139.711], [-12.352, -153.376], [-35.243, -133.882], [-36.005, -124.022], [-40.271, -133.493], [-68.623, -145.921], [-87.695, -121.975], [-83.525, -105.815], [-79.262, -94.967], [-80.452, -94.172], [-81.301, -95.863], [-82.586, -97.219], [-105.692, -103.894], [-123.55, -69.007], [-90.786, 14.203], [-84.875, 29.394], [-95.778, 22.736], [-130.341, 29.41], [-125.052, 63.908], [-115.323, 70.896], [-30.569, 131.312], [39.235, 153.344], [102.853, 125.946], [133.653, 67.808], [134.25, 66.347], [134.379, 61.498]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0.980392158031, 0.972549021244, 0.960784316063, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: 'Layer 4',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 1,
            k: [{
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.75],
                y: [0]
              },
              t: 69,
              s: [0]
            }, {
              i: {
                x: [0.25],
                y: [1]
              },
              o: {
                x: [0.75],
                y: [0]
              },
              t: 80,
              s: [-11.688]
            }, {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.75],
                y: [0]
              },
              t: 88,
              s: [-11.688]
            }, {
              t: 99,
              s: [0]
            }],
            ix: 10
          },
          p: {
            a: 0,
            k: [104.282, 129.579, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [-55.769, 138.462, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [31.303, 31.303, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[-2.729, 15.575], [-9.224, 52.024], [-9.888, 3.083], [-7.428, -7.746], [-1.105, 1.533], [-0.666, -1.164], [-2.541, -2.093], [-1.533, 6.031], [-9.445, 0.752], [-4.718, -10.097], [-1.07, -3.904], [-0.861, 2.944], [-11.639, -0.479], [-2.529, -11.05], [0.936, -5.517], [0.675, -3.826], [-0.441, -0.181], [-0.248, 0.573], [-0.358, 0.51], [-8.979, -0.101], [2.865, -16.495], [5.193, -29.353], [0.923, -5.354], [-2.983, 2.919], [-10.023, -9.403], [8.864, -10.23], [2.73, -2.914], [23.265, -25.731], [25.821, -3.708], [20.872, 12.853], [8.452, 21.429], [0.292, 0.438], [0.485, 1.537]],
                o: [[9.12, -52.042], [1.82, -10.264], [10.206, -3.182], [0.31, 0.323], [0.598, 1.203], [1.5, 2.622], [1.157, -6.127], [2.497, -9.823], [11.941, -0.951], [1.256, 2.688], [0.927, -4.14], [3.213, -10.986], [11.401, 0.469], [1.308, 5.715], [-0.65, 3.83], [0.441, 0.181], [0.159, -0.612], [0.245, -0.565], [5.181, -7.392], [16.157, 0.182], [-5.102, 29.369], [-0.947, 5.35], [3.59, -2.657], [9.833, -9.624], [9.762, 9.157], [-2.613, 3.016], [-23.72, 25.32], [-17.447, 19.296], [-24.304, 3.49], [-19.736, -12.153], [-0.292, -0.438], [-0.358, -1.577], [-4.792, -15.17]],
                v: [[-131.085, 39.52], [-103.458, -116.559], [-85.908, -136.995], [-59.298, -129.698], [-57.638, -129.128], [-55.831, -125.526], [-51.759, -117.451], [-48.219, -135.813], [-27.167, -154.025], [-0.858, -139.471], [1.849, -129.959], [4.148, -140.089], [29.463, -157.905], [52.914, -138.229], [52.04, -121.562], [50.019, -110.083], [51.343, -109.54], [51.838, -111.366], [52.828, -112.951], [74.147, -124.085], [98.583, -93.444], [83.013, -5.382], [80.24, 10.68], [89.602, 1.989], [124.802, 1.659], [126.476, 36.519], [118.33, 45.302], [47.277, 121.36], [-16.755, 156.828], [-84.549, 142.622], [-126.292, 91.767], [-127.167, 90.454], [-128.258, 85.728]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [1, 0.819607853889, 0.250980407, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }, {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: 'Layer 5',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 1,
            k: [{
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.75],
                y: [0]
              },
              t: 69,
              s: [0]
            }, {
              i: {
                x: [0.25],
                y: [1]
              },
              o: {
                x: [0.75],
                y: [0]
              },
              t: 80,
              s: [11.212]
            }, {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.75],
                y: [0]
              },
              t: 88,
              s: [11.212]
            }, {
              t: 99,
              s: [0]
            }],
            ix: 10
          },
          p: {
            a: 0,
            k: [98.126, 151.086, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [63.462, 119.231, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [31.303, 31.303, 100],
            ix: 6
          }
        },
        ao: 0,
        shapes: [{
          ty: 'gr',
          it: [{
            ind: 0,
            ty: 'sh',
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [[5.771, 14.721], [19.381, 49.152], [10.303, 1.056], [5.74, -9.068], [1.387, 1.282], [0.421, -1.273], [2.074, -2.557], [2.702, 5.606], [9.406, -1.141], [2.616, -10.833], [0.273, -4.039], [1.429, 2.714], [11.312, -2.783], [0.282, -11.332], [-2.014, -5.221], [-1.422, -3.615], [0.397, -0.265], [0.357, 0.512], [0.452, 0.429], [8.779, -1.884], [-6.087, -15.596], [-10.925, -27.735], [-1.969, -5.064], [3.504, 2.268], [7.954, -11.207], [-10.72, -8.263], [-3.255, -2.314], [-27.916, -20.593], [-26.043, 1.499], [-17.901, 16.746], [-4.024, 22.682], [-0.199, 0.487], [-0.17, 1.603]],
                o: [[-19.282, -49.19], [-3.824, -9.698], [-10.634, -1.09], [-0.24, 0.379], [-0.347, 1.298], [-0.949, 2.868], [-2.352, -5.774], [-4.4, -9.131], [-11.892, 1.442], [-0.697, 2.884], [-1.731, -3.873], [-5.333, -10.128], [-11.08, 2.726], [-0.146, 5.861], [1.398, 3.625], [-0.397, 0.265], [-0.277, -0.568], [-0.353, -0.505], [-6.547, -6.215], [-15.798, 3.39], [10.838, 27.769], [1.991, 5.055], [-4.046, -1.89], [-11.549, -7.477], [-7.747, 10.915], [3.161, 2.436], [28.28, 20.1], [20.934, 15.443], [24.513, -1.411], [16.926, -15.834], [0.199, -0.487], [0.037, -1.617], [1.681, -15.82]],
                v: [[127.965, 15.65], [69.864, -131.822], [48.602, -148.362], [23.974, -135.921], [22.46, -135.032], [21.406, -131.143], [19.02, -122.419], [11.9, -139.711], [-12.352, -153.376], [-35.243, -133.882], [-36.005, -124.022], [-40.271, -133.493], [-68.623, -145.921], [-87.695, -121.975], [-83.525, -105.815], [-79.262, -94.967], [-80.452, -94.172], [-81.301, -95.863], [-82.586, -97.219], [-105.692, -103.894], [-123.55, -69.007], [-90.786, 14.203], [-84.875, 29.394], [-95.778, 22.736], [-130.341, 29.41], [-125.052, 63.908], [-115.323, 70.896], [-30.569, 131.312], [39.235, 153.344], [102.853, 125.946], [133.653, 67.808], [134.25, 66.347], [134.379, 61.498]],
                c: true
              },
              ix: 2
            },
            nm: 'Path 1',
            mn: 'ADBE Vector Shape - Group',
            hd: false
          }, {
            ty: 'fl',
            c: {
              a: 0,
              k: [0.356862745098, 0.733333333333, 0.988235294118, 1],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
          }, {
            ty: 'tr',
            p: {
              a: 0,
              k: [0, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: 'Transform'
          }],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }],
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }],
      markers: []
    },
    "data-ppui": "true"
  }));
};
var ManageRiskPictogram = function (props) {
  var componentProps = _objectSpread$1({
    'aria-label': 'manage-risk'
  }, props);

  return /*#__PURE__*/React.createElement(LottieContainer, _extends({}, componentProps, {
    animationData: {
      v: '5.9.0',
      fr: 25,
      ip: 0,
      op: 251,
      w: 200,
      h: 200,
      nm: '008 Manage Risk - Spin 2',
      ddd: 0,
      assets: [{
        id: 'comp_0',
        nm: '008 Manage Risk - Spin',
        fr: 25,
        layers: [{
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: 'Layer 3',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [99.999, 100, 0],
              ix: 2,
              l: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1,
              l: 2
            },
            s: {
              a: 0,
              k: [144.018, 144.018, 100],
              ix: 6,
              l: 2
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [0, 3.496], [5.216, 0], [0, -5.216], [-2.823, -1.633], [0, 0], [-2.608, 0], [0, 2.608]],
                  o: [[2.823, -1.633], [0, -5.216], [-5.216, 0], [0, 3.496], [0, 0], [0, 2.608], [2.608, 0], [0, 0]],
                  v: [[4.722, 3.459], [9.444, -4.722], [0, -14.167], [-9.444, -4.722], [-4.722, 3.459], [-4.722, 9.444], [0, 14.167], [4.722, 9.444]],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [0, 0.109803922474, 0.392156869173, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }],
          ip: 0,
          op: 294,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'Layer 1',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [99.998, 100, 0],
              ix: 2,
              l: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1,
              l: 2
            },
            s: {
              a: 0,
              k: [144.018, 144.018, 100],
              ix: 6,
              l: 2
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[-13.692, 0], [0, -13.692], [13.692, 0], [0, 13.692]],
                  o: [[13.692, 0], [0, 13.692], [-13.692, 0], [0, -13.692]],
                  v: [[0, -24.792], [24.792, 0], [0, 24.792], [-24.792, 0]],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.980392158031, 0.972549021244, 0.960784316063, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }],
          ip: 0,
          op: 294,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: 'Layer 2',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 1,
              k: [{
                i: {
                  x: [0.37],
                  y: [1]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                t: 10,
                s: [0]
              }, {
                i: {
                  x: [0.37],
                  y: [1]
                },
                o: {
                  x: [0.63],
                  y: [0]
                },
                t: 15,
                s: [-16.283]
              }, {
                t: 36,
                s: [180]
              }],
              ix: 10
            },
            p: {
              a: 0,
              k: [100, 100, 0],
              ix: 2,
              l: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1,
              l: 2
            },
            s: {
              a: 0,
              k: [144.018, 144.018, 100],
              ix: 6,
              l: 2
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[1.665, 0.748], [0, 0], [0.237, 0.573], [0.442, 0.439], [0.578, 0.238], [0.626, 0], [0, 0], [0.578, -0.238], [0.442, -0.439], [0.237, -0.573], [-0.003, -0.619], [0, 0], [1.472, -1.013], [0, 0], [1.195, -0.309], [0.64, -1.043], [0, 0], [-0.328, -1.203], [-1.088, -0.63], [0, 0], [0, -0.907], [0, -0.88], [0, 0], [0.328, -1.203], [-0.619, -1.085], [0, 0], [-0.497, -0.376], [-0.605, -0.159], [-0.62, 0.083], [-0.54, 0.311], [0, 0], [-1.619, -0.763], [0, 0], [-0.237, -0.573], [-0.442, -0.439], [-0.578, -0.238], [-0.626, 0], [0, 0], [-0.578, 0.238], [-0.442, 0.439], [-0.237, 0.573], [0.004, 0.619], [0, 0], [-1.472, 1.013], [0, 0], [-1.195, 0.319], [-0.632, 1.052], [0, 0], [-0.084, 0.613], [0.161, 0.597], [0.38, 0.491], [0.542, 0.309], [0, 0], [0, 0.88], [0, 0.88], [0, 0], [-0.38, 0.491], [-0.161, 0.597], [0.084, 0.613], [0.315, 0.534], [0, 0], [0.497, 0.376], [0.605, 0.159], [0.62, -0.083], [0.54, -0.311], [0, 0]],
                  o: [[0, 0], [0.003, -0.619], [-0.237, -0.573], [-0.442, -0.439], [-0.578, -0.238], [0, 0], [-0.626, 0], [-0.578, 0.238], [-0.442, 0.439], [-0.237, 0.573], [0, 0], [-1.619, 0.763], [0, 0], [-1.075, -0.6], [-1.195, 0.309], [0, 0], [-0.619, 1.085], [0.328, 1.203], [0, 0], [0, 0.88], [0, 0.907], [0, 0], [-1.088, 0.63], [-0.328, 1.203], [0, 0], [0.313, 0.535], [0.497, 0.376], [0.604, 0.159], [0.62, -0.083], [0, 0], [1.472, 1.013], [0, 0], [-0.003, 0.619], [0.237, 0.573], [0.442, 0.439], [0.578, 0.238], [0, 0], [0.626, 0], [0.578, -0.238], [0.442, -0.439], [0.237, -0.573], [0, 0], [1.619, -0.763], [0, 0], [1.082, 0.595], [1.195, -0.319], [0, 0], [0.315, -0.534], [0.084, -0.613], [-0.161, -0.597], [-0.38, -0.491], [0, 0], [0, -0.88], [0, -0.88], [0, 0], [0.542, -0.309], [0.38, -0.491], [0.161, -0.597], [-0.084, -0.613], [0, 0], [-0.313, -0.535], [-0.497, -0.376], [-0.605, -0.159], [-0.62, 0.083], [0, 0], [-1.516, -1.01]],
                  v: [[14.285, -29.774], [14.285, -37.778], [13.93, -39.583], [12.902, -41.115], [11.357, -42.14], [9.532, -42.5], [-9.531, -42.5], [-11.356, -42.14], [-12.901, -41.115], [-13.93, -39.583], [-14.284, -37.778], [-14.284, -29.774], [-18.928, -27.106], [-25.841, -31.028], [-29.38, -31.482], [-32.24, -29.374], [-41.772, -13.073], [-42.226, -9.503], [-40.017, -6.643], [-33.212, -2.695], [-33.212, -0.027], [-33.212, 2.641], [-40.125, 6.563], [-42.334, 9.423], [-41.88, 12.993], [-32.24, 29.321], [-31.014, 30.7], [-29.345, 31.509], [-27.49, 31.624], [-25.733, 31.028], [-18.82, 27.106], [-14.176, 29.774], [-14.176, 37.778], [-13.822, 39.583], [-12.793, 41.115], [-11.248, 42.14], [-9.423, 42.5], [9.64, 42.5], [11.465, 42.14], [13.01, 41.115], [14.038, 39.583], [14.393, 37.778], [14.393, 29.774], [19.037, 27.106], [25.949, 31.028], [29.5, 31.459], [32.349, 29.321], [41.854, 13.02], [42.457, 11.283], [42.341, 9.45], [41.522, 7.802], [40.126, 6.59], [33.213, 2.641], [33.213, -0.027], [33.213, -2.695], [40.126, -6.617], [41.522, -7.828], [42.341, -9.477], [42.457, -11.309], [41.854, -13.046], [32.349, -29.374], [31.122, -30.753], [29.454, -31.563], [27.599, -31.678], [25.841, -31.081], [19.064, -27.133]],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.35686275363, 0.733333349228, 0.988235294819, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }],
          ip: 0,
          op: 294,
          st: 0,
          bm: 0
        }]
      }],
      layers: [{
        ddd: 0,
        ind: 1,
        ty: 0,
        nm: '008 Manage Risk - Spin',
        refId: 'comp_0',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [100, 100, 0],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [100, 100, 0],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [125, 125, 100],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        w: 200,
        h: 200,
        ip: 0,
        op: 251,
        st: 0,
        bm: 0
      }],
      markers: []
    },
    "data-ppui": "true"
  }));
};

export { AwardAchievedPictogram, CollectDonationsPictogram, DiscountsPictogram, EarnCashBackPictogram, HighFivePictogram, ManageRiskPictogram };
